module.exports = __webpack_public_path__ + "img/premium_movies.854021b.svg";